import api from "Common/Client/Interceptor";
const getToken = () => localStorage.getItem("token");

export const fetchCourses = async (mentorId) => {
  try {
    const response = await api.get(`/Library/Mentor/Get-Courses-List?mentorId=${mentorId}`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};